<template>
  {{ category ? category.name : "..." }}
</template>

<script>
  export default {
    name: "CategoryName",
    props: {
      id: {
        required: true,
      },
    },
    computed: {
      category() {
        return this.$store.getters["categories/id"](this.id)
      }
    },
    watch: {
      category: {
        immediate: true,
        handler() {
          if(this.category != null) return
          this.$store.dispatch("categories/getById", this.id)
        }
      },
    },
  }
</script>

